import styled from 'styled-components';
import { theme } from '@/styles/theme';
import { Container, Section } from '@/components/ui/Container';
import { Card, CardContent, CardTitle } from '@/components/ui/Card';
import { FadeInWhenVisible } from '@/components/animations/FadeInWhenVisible';
import { Calendar, User } from 'lucide-react';

const PageHeader = styled(Section)`
  background: ${theme.colors.primary.navy};
  color: ${theme.colors.neutral.white};
  text-align: center;
  padding: ${theme.spacing[24]} 0 ${theme.spacing[16]};
`;

const PageTitle = styled.h1`
  color: ${theme.colors.neutral.white};
`;

const NewsGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: ${theme.spacing[8]};

  @media (max-width: ${theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
  }
`;

const ArticleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[6]};
`;

const ArticleCard = styled(Card)`
  cursor: pointer;
`;

const ArticleImage = styled.div`
  width: 100%;
  height: 250px;
  background: linear-gradient(135deg, ${theme.colors.secondary.ivory}, ${theme.colors.secondary.cream});
  border-radius: ${theme.borderRadius.lg};
  margin-bottom: ${theme.spacing[4]};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.neutral.gray};
`;

const ArticleMeta = styled.div`
  display: flex;
  gap: ${theme.spacing[4]};
  margin-bottom: ${theme.spacing[3]};
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.neutral.gray};
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};

  svg {
    color: ${theme.colors.primary.royalBlue};
  }
`;

export const NewsPage = () => {
  const articles = [
    {
      id: 1,
      title: 'Succesvol Nieuwjaarsconcert 2025',
      excerpt: 'Ons nieuwjaarsconcert was opnieuw een groot succes met een volle zaal...',
      date: '15 januari 2025',
      author: 'Redactie',
    }
  ];

  return (
    <>
      <PageHeader>
        <Container>
          <PageTitle>Berichten & Nieuws</PageTitle>
        </Container>
      </PageHeader>

      <Section>
        <Container>
          <NewsGrid>
            <ArticleList>
              {articles.map((article, index) => (
                <FadeInWhenVisible key={article.id} delay={index * 0.1}>
                  <ArticleCard interactive elevated>
                    <ArticleImage>[Artikel Foto]</ArticleImage>
                    <CardContent>
                      <CardTitle>{article.title}</CardTitle>
                      <ArticleMeta>
                        <MetaItem>
                          <Calendar size={16} />
                          <span>{article.date}</span>
                        </MetaItem>
                        <MetaItem>
                          <User size={16} />
                          <span>{article.author}</span>
                        </MetaItem>
                      </ArticleMeta>
                      <p>{article.excerpt}</p>
                    </CardContent>
                  </ArticleCard>
                </FadeInWhenVisible>
              ))}
            </ArticleList>

            <div>
              <FadeInWhenVisible>
                <Card>
                  <CardContent>
                    <CardTitle>Categorieën</CardTitle>
                    {/* Categories would go here */}
                  </CardContent>
                </Card>
              </FadeInWhenVisible>
            </div>
          </NewsGrid>
        </Container>
      </Section>
    </>
  );
};
